// import { useState, useEffect } from "react";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { useMutation } from "@tanstack/react-query";
// import { toast } from "react-toastify";
// import { useForm, Controller } from "react-hook-form";
// import { useQuill } from "react-quilljs";
// import Label from "../../ChildComponents/Label";
// // child

// import BrandButton from "../../ChildComponents/BrandButton";

// // validationSchema
// import { Rolechema } from "../validation/roleValidation";

// // api

// import { useCreateInfo, useGetInfo } from "../../store/api/foooterApi";

// function Form({ data, editId, onSuccessCreated }) {
//   const createInfo = useCreateInfo(editId?._id);
//   const { quill, quillRef } = useQuill();

//   // init
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     reset,
//     control,
//     watch,
//   } = useForm({
//     resolver: yupResolver(Rolechema),
//   });

//   useEffect(() => {
//     if (editId) {
//       reset({
//         details: editId.details || "",
//       });
//       setEdited(true);
//     } else {
//       reset({
//         details: "",
//       });
//       setEdited(false);
//     }
//   }, [editId, reset]);

//   const [loading, setLoading] = useState(false);
//   const [edited, setEdited] = useState(editId ? true : false);

//   const mutation = useMutation({
//     mutationFn: (data) => {
//       return createInfo(data);
//     },
//     onSuccess: (data) => {
//       setLoading(false);
//       toast.success("Creatred Successfuly");
//       reset();
//       onSuccessCreated(1);
//     },
//     onError: (error) => {
//       toast.error(error.message);
//       setLoading(false);
//     },
//   });

//   const onSubmit = async (formData) => {
//     setLoading(true);
//     try {
//       const data = {
//         details: formData.details, // ✅ Send as plain JSON
//       };

//       mutation.mutate(data);
//     } catch (error) {
//       toast.error("Something went wrong.");
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       <form onSubmit={handleSubmit(onSubmit)} action="">
//         <div className="row">
//           <div className="col-sm-9">
//             <div className="row">
//               <div className="col-sm-12">
//                 <p className="brand-text border-bottom border-primary my-4">
//                   Footer Infomation
//                 </p>
//               </div>
//               {/* meta Description */}
//               <div className="col-sm-6">
//                 <Label className="mt-3" label={`Discription `} />
//                 <Controller
//                   name="details"
//                   control={control}
//                   defaultValue=""
//                   render={({ field }) => (
//                     <ReactQuill
//                       {...field}
//                       theme="snow"
//                       className="bg-white"
//                       onChange={(content) => field.onChange(content)}
//                     />
//                   )}
//                 />
//               </div>

//               <BrandButton
//                 type="submit"
//                 // title={`${!loading ? "Login" : "Loading...."}`}
//                 title={`Save Change`}
//                 className="my-5"
//               />
//             </div>
//           </div>
//           <div className="col-sm-3"></div>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default Form;

import { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css"; // ✅ CSS import

import Label from "../../ChildComponents/Label";
import BrandButton from "../../ChildComponents/BrandButton";

// validationSchema
import { Rolechema } from "../validation/roleValidation";

// api
import { useCreateInfo, useGetInfo } from "../../store/api/foooterApi";

function Form({ data, editId, onSuccessCreated }) {
  const createInfo = useCreateInfo(editId?._id);

  // ✅ Quill setup
  const { quill, quillRef } = useQuill({
    modules: {
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }, { background: [] }],
        ["link", "image"],
        ["clean"],
      ],
    },
  });

  const [loading, setLoading] = useState(false);
  const [edited, setEdited] = useState(editId ? true : false);
  const [editorContent, setEditorContent] = useState(""); // ✅ Editor content state

  // init
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(Rolechema),
  });

  // ✅ Quill editor এর content handle করা
  useEffect(() => {
    if (quill) {
      // Text change listener
      quill.on("text-change", () => {
        const content = quill.root.innerHTML;
        setEditorContent(content);
        setValue("details", content); // React Hook Form এ value set করা
      });
    }
  }, [quill, setValue]);

  // ✅ Edit mode এ initial value load করা
  useEffect(() => {
    if (editId) {
      reset({
        details: editId.details || "",
      });
      setEdited(true);

      // Quill এ content load করা
      if (quill && editId.details) {
        quill.clipboard.dangerouslyPasteHTML(editId.details);
      }
    } else {
      reset({
        details: "",
      });
      setEdited(false);

      // Quill clear করা
      if (quill) {
        quill.setText("");
      }
    }
  }, [editId, reset, quill]);

  const mutation = useMutation({
    mutationFn: (data) => {
      return createInfo(data);
    },
    onSuccess: (data) => {
      setLoading(false);
      toast.success("Created Successfully");
      reset();

      // Quill clear করা
      if (quill) {
        quill.setText("");
      }

      onSuccessCreated(1);
    },
    onError: (error) => {
      toast.error(error.message);
      setLoading(false);
    },
  });

  const onSubmit = async (formData) => {
    setLoading(true);
    try {
      const data = {
        details: editorContent || formData.details, // ✅ Editor content use করা
      };

      mutation.mutate(data);
    } catch (error) {
      toast.error("Something went wrong.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} action="">
        <div className="row">
          <div className="col-sm-9">
            <div className="row">
              <div className="col-sm-12">
                <p className="brand-text border-bottom border-primary my-4">
                  Footer Information
                </p>
              </div>

              {/* Description with Quill Editor */}
              <div className="col-sm-12">
                <Label className="mt-3" label={`Description`} />
                <div style={{ minHeight: "300px" }}>
                  <div ref={quillRef} />
                </div>
                {errors.details && (
                  <p className="text-danger mt-2">{errors.details.message}</p>
                )}
              </div>

              <BrandButton
                type="submit"
                title={loading ? "Loading...." : "Save Change"}
                className="my-5"
                disabled={loading}
              />
            </div>
          </div>
          <div className="col-sm-3"></div>
        </div>
      </form>
    </div>
  );
}

export default Form;
